import React from 'react';
import { theme } from 'antd';

function PitchBackground() {
  const { token } = theme.useToken();
  return (
    <svg
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        opacity: 0.06,
        pointerEvents: 'none',
        zIndex: 0,
      }}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <defs>
        <pattern id="pitch-tile" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
          <polygon
            points="40,8 62,20 62,44 40,56 18,44 18,20"
            fill="none"
            stroke={token.colorPrimary}
            strokeWidth="1.5"
          />
          <circle cx="40" cy="32" r="5" fill="none" stroke={token.colorPrimary} strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#pitch-tile)" />
    </svg>
  );
}

export default PitchBackground;
